import React from 'react';


import {ChunkedDownloadTool} from 'src/components/chuncked-download-tool';
import {DownloadButton} from 'src/components/form-buttons';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {downloadAccountInfo} from 'src/openapi/admin/apis/AccountSearchDownloadRequestApi';
import {useAppDispatch} from 'src/store/hooks';

import {Group} from '@pb/kit-component-group';

import {
    ACCOUNT_DOWNLOAD_FILE_HEADERS,
    ACCOUNT_DOWNLOAD_FILE_NAME,
    ACCOUNT_DOWNLOAD_TASK_NAME,
} from './constants';

type Props = {
    accountIds: number[],
    viewType: string,
};
export const AccountDownloadTool = ({accountIds, viewType}: Props) => {
    const apiDispatch = useAppDispatch();
    const {hasAccess} = useAdminAccessRight();
    const {searchCriteriaDownload} = useEventTracking();

    return (
        <ChunkedDownloadTool
            ids={accountIds}
            taskName={ACCOUNT_DOWNLOAD_TASK_NAME}
            fileName={ACCOUNT_DOWNLOAD_FILE_NAME}
            fileHeaders={ACCOUNT_DOWNLOAD_FILE_HEADERS}
            getData={ids => apiDispatch(downloadAccountInfo({entityDownloadInfoRequest: {ids}}))}
            chunkSize={250}>
            {handler => (
                <Group alignItems="center">
                    {hasAccess(ACCESS_RIGHTS.ACCOUNT_SCREEN_VIEW) && (
                        <DownloadButton
                            disabled={!accountIds.length}
                            handler={() => {
                                searchCriteriaDownload({viewType});
                                handler();
                            }}
                        />
                    )}
                </Group>
            )}
        </ChunkedDownloadTool>
    );
};
